"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useDocOnce;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _context = _interopRequireDefault(require("../context"));

function useDocOnce(props) {
  var path = props.path;

  var _useContext = (0, _react.useContext)(_context["default"]),
      app = _useContext.app;

  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      data = _useState4[0],
      setData = _useState4[1];

  (0, _react.useEffect)(function () {
    if (app) {
      var ref = app.firestore().doc(path);
      ref.get().then(function (doc) {
        if (doc.exists) {
          setData({
            id: doc.id,
            data: doc.data()
          });
        } else {
          setData(null);
        }

        setIsLoading(false);
      })["catch"](function (err) {
        setIsLoading(false); // eslint-disable-next-line no-console

        console.log(err);
      });
    }
  }, [app, path]);
  return [data, isLoading];
}